var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cmsPageContent)?_c('div',{staticClass:"cms-slug",class:{
    'container-EXPONDO': _vm.isInsideContainer,
    'lg:flex lg:py-10': _vm.cmsSideMenu
  }},[(_vm.cmsSideMenu)?_c('render-content',{staticClass:"lg:w-1/4",attrs:{"content":[_vm.cmsSideMenu]}}):_vm._e(),_vm._v(" "),_c('render-content',{class:{ 'px-6 lg:w-3/4': _vm.cmsSideMenu,
              'flex flex-col gap-4' : _vm.isHomePage
    },attrs:{"content":_vm.cmsPageContent,"is-components-overview-page":_vm.isComponentsOverviewPage}}),_vm._v(" "),(_vm.isHomePage)?_c('trusted-by'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }